import { createSlice } from "@reduxjs/toolkit"

import {
  clearProductObjCacheHandler,
  saveProductObjCacheHandler
} from "./productObjCacheActionHandlers"
import { ProductObjCacheState } from "./types"

const productObjCacheSlice = createSlice({
  name: "productObjCache",
  initialState: {} as ProductObjCacheState,
  reducers: {
    saveProductObjCache: saveProductObjCacheHandler,
    clearProductObjCache: clearProductObjCacheHandler
  }
})

export const { saveProductObjCache, clearProductObjCache } =
  productObjCacheSlice.actions

const { actions } = productObjCacheSlice

export { actions }

export default productObjCacheSlice.reducer
